import { adaptToDatabase } from '../../../utils/adaptToDatabase'
import { unifyParams } from '../../../utils/unifyParams'
import apinode from '../../apinode'

class WmsProductService {
  constructor() {
    this.idconta = localStorage.idconta
  }

  async getAll(params) {
    const url = unifyParams(`/wmsProduct/${this.idconta}`, [
      {
        key: params?.type,
        value: params?.search,
      },
    ])

    const response = await apinode.get(url)

    return response.data
  }

  async searchProducts(search) {
    const response = await apinode.get(
      `/wmsProduct/product/${this.idconta}?search=${search}`,
    )

    return response.data
  }

  async getAddressesOfProduct(sku) {
    const response = await apinode.get(
      `/wmsProduct/addresses/${sku}/${this.idconta}`,
    )

    return response.data
  }

  async getBySku(sku) {
    const response = await apinode.get(`/wmsProduct/${sku}/${this.idconta}`)

    return response.data
  }

  async getAdjustmentBySku(sku) {
    const response = await apinode.get(
      `/wmsProduct/adjustment/${sku}/${this.idconta}`,
    )

    return response.data
  }

  async create(data) {
    const decimalFields = [
      'qtunitmaster',
      'alturaarm',
      'larguraarm',
      'pesoliqarm',
      'pesobrutoarm',
      'profundidadearm',
      'comprimentoarm',
      'volumearmcm',
      'volumearmm',
      'qtunimasterexp',
      'alturaexp',
      'larguraexp',
      'pesoliqexp',
      'pesobrutoexp',
      'profundidadeexp',
      'comprimentoexp',
      'volumeexpcm',
      'volumeexpm',
      'idembalagem',
      'idcategoria',
    ]

    const dataFormatted = adaptToDatabase(data, decimalFields)

    await apinode.post(`/wmsProduct/${this.idconta}`, {
      data: dataFormatted,
    })
  }

  async update(sku, data) {
    const decimalFields = [
      'qtunitmaster',
      'alturaarm',
      'larguraarm',
      'pesoliqarm',
      'pesobrutoarm',
      'profundidadearm',
      'comprimentoarm',
      'volumearmcm',
      'volumearmm',
      'qtunimasterexp',
      'alturaexp',
      'larguraexp',
      'pesoliqexp',
      'pesobrutoexp',
      'profundidadeexp',
      'comprimentoexp',
      'volumeexpcm',
      'volumeexpm',
      'idembalagem',
    ]

    const dataFormatted = adaptToDatabase(data, decimalFields)

    await apinode.put(`/wmsProduct/${sku}/${this.idconta}`, {
      data: dataFormatted,
    })
  }
}

export default new WmsProductService()
